export const getCookie = (cname) => {
  const name = `${cname}=`;
  /* eslint-disable-next-line no-undef */
  const ca = document.cookie.split(';');

  /* eslint-disable-next-line no-plusplus */
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const setCookie = (cName, cValue, expireTime) => {
  /* eslint-disable-next-line no-undef */
  document.cookie = `${cName}=${cValue};max-age=${expireTime};path=/;`;
};

export const deleteCookie = (cname) => {
  /* eslint-disable-next-line no-undef */
  document.cookie = `${cname}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
